"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableCell = _interopRequireDefault(require("./TableCell.style"));
var _excluded = ["children", "highlight", "maxWidth", "type", "mappedStatus"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TableCell = function TableCell(_ref) {
  var children = _ref.children,
    highlight = _ref.highlight,
    maxWidth = _ref.maxWidth,
    type = _ref.type,
    mappedStatus = _ref.mappedStatus,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_TableCell["default"], _extends({
    highlight: highlight,
    type: type,
    mappedStatus: mappedStatus,
    maxWidth: maxWidth
  }, otherProps), type === 'status' && /*#__PURE__*/_react["default"].createElement("span", {
    className: "status-dot"
  }), children);
};
TableCell.propTypes = {
  /** The alignment of the table text */
  align: _propTypes["default"].oneOf(['right', 'left', 'center']),
  /**
   * The content of the table cell, normally a node or a string.
   * */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  /**
   * Flag to indicate wheather the currenct cell should be highlighted.
   * */
  highlight: _propTypes["default"].bool,
  /**
   * Width in pixels if a certain column should have a maximum width
   * */
  maxWidth: _propTypes["default"].number,
  type: _propTypes["default"].oneOf(['date', 'status', 'checkbox', 'feedbackScore', '']),
  mappedStatus: _propTypes["default"].shape({})
};
TableCell.defaultProps = {
  align: 'left',
  children: '',
  highlight: false,
  maxWidth: undefined,
  type: null,
  mappedStatus: null
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(TableCell);